    export const tableColumns = [
        {
            Header: "No",
  

        },
        {
            Header: "Customer Name",
            accessor: "company_name",
        
        },
        {
            Header: "Invoice Remaining Amount (Unpaid)",
            accessor: "remaining_amount",
            Cell: ({value}) => {
                if (value === null) return "-";
                return Number(value).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            }
       
        },
    ];